export const WORK_ORDER_APP_TYPE = {
  'dispatch': 'DISPATCH_REDIRECT',
  'appointment': 'CHANGE_APPOINTMENT_TIME',
  'address': 'CHANGE_ADDRESS',
  'project': 'CHANGE_PROJECT',
  'bargain': 'BARGAIN',
  'order': 'ORDER_REPORT',
  'other': 'OTHER_ISSUE'
};
